module.exports = __webpack_public_path__ + "static/img/image_we_06_02.47730fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_we_06_02.png
// module id = j5FR
// module chunks = 10